import { render, staticRenderFns } from "./v-home.vue?vue&type=template&id=27154fe8&scoped=true&"
import script from "./v-home.vue?vue&type=script&lang=js&"
export * from "./v-home.vue?vue&type=script&lang=js&"
import style0 from "./v-home.vue?vue&type=style&index=0&id=27154fe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27154fe8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VContainer,VList,VListItem,VListItemTitle,VMenu})
